import utagLinkGeneric from './utagLinkGeneric';

function utagLinkCheckout (eventCategory = 'Checkout') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkCheckout;
